// extracted by mini-css-extract-plugin
export default {"needMoreDateContainer":"needMoreDate_needMoreDateContainer__alb-c","errorIcon":"needMoreDate_errorIcon__Fa87F","errorMessage":"needMoreDate_errorMessage__RpUl5"};